import { LAYOUT_ORIENTATION } from 'constants/layout';
import { BaseLayout } from './base_layout';

export class StackableLayout extends BaseLayout {
    computeLayout() {
        this.makeStackable();
        this.divideSpace();
    }

    makeStackable() {
        this.children.forEach(c => {
            if (this.orientation === LAYOUT_ORIENTATION.HORIZONTAL) {
                c.height = 100;
            } else if (this.orientation === LAYOUT_ORIENTATION.VERTICAL) {
                c.width = 100;
            }
        });
    }

    divideSpace() {
        let dimension = 'width',
            direction = 'left',
            fixedDir = 'top',
            increment = 0;

        if (this.orientation === LAYOUT_ORIENTATION.VERTICAL) {
            dimension = 'height';
            direction = 'top';
            fixedDir = 'left';
        }

        const reservedSize = this.children.reduce((total, c) => isNaN(c[dimension]) ? total : total + c[dimension], 0),
            unreservedCount = this.children.filter(c => isNaN(c[dimension])).length,
            unreservedSize = (100 - reservedSize) / unreservedCount;

        this.children.forEach(c => {
            if (isNaN(c[dimension])) {
                c[dimension] = unreservedSize;
            }

            c[fixedDir] = 0;
            c[direction] = increment;
            increment += c[dimension];
        });
    }
}